

export default {
  scrollToTop: true,
  async asyncData({ app, store, error }) {
    if (!process.server) return
  },
  name: 'commonTitle',
  props: {
    title: {
      type: String,
      default: 'home.headTitle'
    },
    subTitle: {
      type: String,
      default: '',
    },
    lineWidth: {
      type: String,
      default: '38px'
    },
    paddingBottom:{
      type: String,
      default: '57px'
    },
    showDashed: {
      type: Boolean,
      default: true
    },
    label:{
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: 'full-content-12'
    }
  },
  computed:{
    titleStr(){
      return this.$t(this.title)
    },
    labelStr(){
      if(!this.label) {
        return ''
      }
      return this.$t(this.label)
    },
    subTitleStr() {
      if(!this.subTitle) {
        return ''
      }
      return this.$t(this.subTitle)
    }
  },
  data() {
    return {

    }
  },
  mounted() {

  },
  methods: {

  }
}
